import { useFlag } from '@/features/unleash';
import loadable from '@loadable/component';
import type { CompanyReportSection } from '@/pages/CompanyReport/useSection';
import { getGridViewOptionIdBySection, getTitleBySection } from './utils';

const NextStep = loadable(() => import('../NextStep'));

interface Props {
  originalElement: JSX.Element;
  section: CompanyReportSection;
}

export const useExperimentPeerCompanies = ({
  originalElement,
  section,
}: Props) => {
  const featureFlag = useFlag({ name: 'mono-next-steps-companies' });
  const isExperimentPeerCompanies =
    featureFlag.flagsReady &&
    featureFlag.enabled &&
    featureFlag.variant.name === 'variant';

  const gridViewOptionId = getGridViewOptionIdBySection(section);
  const title = getTitleBySection(section);

  if (isExperimentPeerCompanies) {
    return (
      <NextStep
        section={section}
        gridViewOptionId={gridViewOptionId}
        title={title}
      />
    );
  }
  return originalElement;
};
